import { t } from 'translations'

import { getRoutes, hasAccessToThis } from 'services/Utilities'
import { Badge } from 'ui'

import { RouterLink } from 'ui'

const ManagerMenuMobile: React.FC = () => {
  const { pathname } = location

  const sortedManagerRoutes = getRoutes('manager', true)
  return (
    <nav className="navbar bg-primary navbar-dark merinio-collapse-container">
      <div className="collapse navbar-collapse merinio-navbar-collapse" id="navBarManagerContent">
        <ul className="navbar-nav mr-auto">
          {/* Dashboard link on manager page */}
          <>
            <li className={`nav-item${pathname.includes('/manage/dashboard') ? ' active' : ''}`} data-toggle="collapse" data-target=".navbar-collapse.show">
              <RouterLink className="nav-link px-2" to="/manage/dashboard">
                <span className="mr-2">
                  <i className="fad fa-home-lg-alt" />
                </span>
                {t(`manager.DASHBOARD`)}
              </RouterLink>
            </li>
            <div className="nav-item nav-divider" />
          </>
          {sortedManagerRoutes.map(route => {
            if (!route.permission) return null
            if (!route.title || !hasAccessToThis(route.permission)) return null
            return (
              <li
                key={route.title}
                className={`nav-item${pathname.includes(route.path) ? ' active' : ''}`}
                data-toggle="collapse"
                data-target=".navbar-collapse.show"
              >
                <RouterLink className={`nav-link px-2`} key={`mobile-${route.title}`} to={route.path}>
                  <span className="mr-2">
                    <i className={`fad fa-${route.icon}`} />
                  </span>
                  {t(`manager.${route.title}`)}
                  {route.isAlpha ? (
                    <Badge variant="danger" className="ml-2">
                      Alpha
                    </Badge>
                  ) : null}
                  {route.isBeta ? (
                    <Badge variant="warning" className="ml-2">
                      Beta
                    </Badge>
                  ) : null}
                </RouterLink>
              </li>
            )
          })}
        </ul>
      </div>
    </nav>
  )
}

export default ManagerMenuMobile
